import React, { Component } from "react";
import { Form, Row, Col,Label,FormGroup } from "reactstrap";
import { MdCancel } from "react-icons/md";
import { IoMdClose } from "react-icons/io";

import {
  Validator,
  submitValidator,
  refresh,

} from "../../../../common/Validator";
import { withRouter } from "react-router-dom";

import Notifier from "../../../aside/Notifier";
import ErrorNotifier from "../../../aside/ErrorNotifier";
import axios from "axios";
import { API_CANDIDATE } from "../../../../utils/config";
import Button from "@material-ui/core/Button";
import {RS_API} from '../../../../utils/config'
import SelectDropDown from './selectDropDown'

import { getProfileInfo} from "../../../../redux/action/profileInfoAction"
import { connect } from "react-redux";

import Select from 'react-select'




// import { KeyboardReturnTwoTone } from "@material-ui/icons";

/**
 * UpdateTechnical Component for updating the technical details.
 */
var  dropdownError = "";

var primarySkillGroupError = ""

var isPrimaryValid = true
var isPrimarySkillValid = true

class UpdateTechnicalSkils extends Component {
  constructor(props) {
    super(props);

    this.state = {
      primarySkill: this.props.updateDataProp
        ? this.props.updateDataProp.skill
        : "",
      
        primarySkillGroup: this.props.updateDataProp
        ? this.props.updateDataProp.skillGroup
        : "",
      
    
   
   
      id: this.props.updateDataProp ? this.props.updateDataProp.id : undefined,
      message: "",
      buttonAction:false,
      dropdownError:"",
      skillsData:[],
      secondarySkillsData:[],
      secondaryData:[],
      skillVersionData:[],
      error: "",
      data:[],
      groupId:null,
      primaryBodyName:"",
    primaryGroupData:[{
        id:0,
        skill:"select"

      }],
      filteredValueArray:this.props.updateDataProp ? this.props.updateDataProp.skill.split(','): [],
    
      optPrimaryData:[]
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
    this.getData = this.getData.bind(this)
    this.closeDataSkill = this.closeDataSkill.bind(this)
    this.onChangePrimaryDrop = this.onChangePrimaryDrop.bind(this)
    this.onChangeDrop = this.onChangeDrop.bind(this)
  
  }
//  common onchange function
  onChange(e) {
   Validator(e.target);
    this.setState({
      [e.target.name]: e.target.value,
      buttonAction:false
    });
   
  }

  // onchange function for primary skill group data
  onChangeDrop(data){
 
    const find = this.state.data.find((x)=>x.skillGroup === data.target.value)
 
    this.setState({
      primarySkillGroup: data.target.value,
      filteredValueArray:[],
      buttonAction:false,
      skillsData:find? find:[],
    });
   
   
    dropdownError = ""
  }
  // onchange function for primary skill data
  onChangePrimaryDrop(primarySkill){
  
    let {filteredValueArray} = this.state
    filteredValueArray.push(primarySkill.value)
    this.setState({
      primaryBodyName: primarySkill.value,
      filteredValueArray: [...new Set(filteredValueArray)]
    });

    console.log(this.state.filteredValueArray)


    if (primarySkill) {
      this.setState({ primarySkill,  buttonAction:false});
    }
    primarySkillGroupError = ""
  }


  closeDataSkill(data){
  console.log(data)

  let filterData = this.state.filteredValueArray.filter(val=>val!==data)
  this.setState({
    filteredValueArray:filterData
  })
  }


 
 
 // update function by clicking update button
  onUpdate(e) {
  e.preventDefault();
    submitValidator(e.target);
    if (!this.state.primarySkillGroup || this.state.primarySkillGroup ==="select") {
      dropdownError = "Please select primary Group";
      isPrimaryValid = false
    
    } else {
      dropdownError = "";
      isPrimaryValid = true
    }
   
   let data = {
      canInfoId:this.props.profile.data.id,
     skill:this.state.filteredValueArray.toString(),
     skillGroup:this.state.primarySkillGroup,
     id: this.state.id,
    };
    // if(!this.state.primarySkillVersion.length) delete data.primarySkillVersion
    // if(!this.state.secondarySkillVersion) delete data.secondarySkillVersion
    // if(!this.state.secondarySkillGroup) delete data.secondarySkillGroup

    this.setState({
      buttonAction:true
    })

    let apiResult = this.props.isSecondarybutton ? `${API_CANDIDATE}/v1/api/can-secondary-skill`:
    `${API_CANDIDATE}/v1/api/can-primary-skill`

    if (isPrimaryValid) {
      axios
        .put(apiResult, data, {
          withCredentials: true,
        })
        .then((res) => {
          console.log(res);
          if (res.data.ok) {
            this.setState({
              message: "Updated successfully ",
            });
            setTimeout(() => {
              this.setState({
                message: "",
              });
              this.props.back();
            }, 2000);
          }
          else if(!res.data.ok){
            console.log("error logged")
            this.setState({
              error: res.data.message,
            });
            setTimeout(() => {
              this.setState({
                error: "",
              });
             
            }, 2000);
          }
         
        })
        .catch((err) => {
          if (err.response &&err.response.data.statusCode === 400) {
            this.setState({
              error:err.response.data.message[0]
            })
              setTimeout(() => {
                this.setState({
                  error:""
                })
              }, 2000);
            }
            else if(!err.response.data.ok){
            this.setState({
                error: err.response.data.message,
              });
              setTimeout(() => {
                this.setState({
                  error: "",
                });
               
              }, 2000);
            }  
            else if (err.response && err.response.data.statusCode === 403) {
           this.setState({
            error:err.response.data.message
            })
             setTimeout(() => {
                this.setState({
                  error: "",
                });
            this.props.history.push("/signin");
               }, 2000);
            }
        });
    } else {
      this.setState({
        error: "Enter all mandatory fields",
      });
      setTimeout(() => {
        this.setState({
          error: "",
        });
      }, 2000);
    }
  }
 // onsubmit function by clicking submit button
  onSubmit(e) {
    e.preventDefault();

    submitValidator(e.target);

    if (!this.state.primarySkillGroup || this.state.primarySkillGroup ==="select") {
      dropdownError = "Please select primary Group";
      isPrimaryValid = false
    } else {
      dropdownError = "";
      isPrimaryValid = true
    }
 

   
    if (!this.state.primaryBodyName || this.state.primarySkill ==="Select") {
      primarySkillGroupError = "Please select primary Skill";
      isPrimarySkillValid = false
    } else {
      primarySkillGroupError = "";
      isPrimarySkillValid = true
    }
  

   
    let data = {
     canInfoId:this.props.profile.data.id,
     skill:this.state.filteredValueArray.toString(),
     skillGroup:this.state.primarySkillGroup,
   };

    this.setState({
      buttonAction: true,
    });

    let apiResult = this.props.isSecondarybutton ? `${API_CANDIDATE}/v1/api/can-secondary-skill`:
    `${API_CANDIDATE}/v1/api/can-primary-skill`
  
    if (isPrimaryValid && isPrimarySkillValid ) {
      axios
        .post(apiResult, data, {
          withCredentials: true,
        })
        .then((res) => {
          console.log(res.data);
          if (res.data.ok) {
            this.setState({
              message: "successfully created",
            });
            setTimeout(() => {
              this.setState({
                message: "",
              });
              this.props.back();
            }, 2000);
          }
       
        })
        .catch((err) => {
          
          if (err.response &&!err.response.data.statusCode === 403) {
            this.setState({
              error:err.response.data.message[0]
            })
              setTimeout(() => {
                this.setState({
                  error:""
                })
              }, 2000);
            }
            else if(!err.response.data.ok){
           this.setState({
                error: err.response.data.message,
              });
              setTimeout(() => {
                this.setState({
                  error: "",
                });
               
              }, 2000);
            } 
            else if (err.response && err.response.data.statusCode === 403) {
           this.setState({
            error:err.response.data.message
            })
             setTimeout(() => {
                this.setState({
                  error: "",
                });
            this.props.history.push("/signin");
               }, 2000);
            }
        });
    } else {
      this.setState({
        error: "Enter all mandatory fields",
      });
      setTimeout(() => {
        this.setState({
          error: "",
        });
      }, 2000);
    }
  }

  componentDidMount() {
   this.getData();
   this.props.getProfileInfo();
    refresh();
    this.setState({
      message: "",
      error: "",
    });
  }



  getData() {
    axios
      .get(`${RS_API}/v1/api/skill-detail/can`, { withCredentials: true })
      .then((res) => {
        console.log(res);

        this.setState({
          data: this.state.data.concat(res.data),
          //Networking === Networking
          skillsData:this.state.data.concat(res.data).find((x)=>x.skillGroup === this.state.primarySkillGroup),
          secondarySkillsData:this.state.data.concat(res.data).find((x)=>x.skillGroup === this.state.secondarySkillGroup)
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  }
 



  render() {
    console.log(this.state.filteredValueArray)
  
    // storing in a array for listing
    let option4 = [];
   let optArr = typeof this.state.skillsData !== "undefined" && 
   Object.keys(this.state.skillsData).length !== 0 ? this.state.skillsData.canSkill : []
   console.log(optArr)
    for (let i = 0; i < optArr.length; i++) {
      var x1 = {};
      x1["label"] = optArr[i].skill
      x1["value"] =optArr[i].skill;

     option4.push(x1);
    }

    
    
   
   
    
    const {primarySkill, primarySkillGroup, message, error } = this.state;
   
    return (
      <>
       {/* applied ternary operator for checking whether it is update or submit form */}
        {!this.props.updateDataProp ? (
          <div style={{ paddingLeft: "2.5rem" }}>
            <i
              className="material-icons cancel-button pointer"
              onClick={this.props.back}
            >
              cancel
            </i>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "24px",
                  fontWeight: "bold",
                  paddingTop: "0.5rem",
                }}
              >
                <span> Technical Skills </span>
              </div>
              <div>
                <Form onSubmit={this.onSubmit} className="p-3" noValidate>
                  <Row>
                    <Col>
                    <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                    Skill Group
                    </span>
                     <SelectDropDown
                     style={{height:"30px"}}
                     tab="1"
                     change={this.onChangeDrop}
                     name={primarySkillGroup}
                     value={primarySkillGroup}
                     options={this.state.data}
                     
                     dropError ={dropdownError}
                     >


                     </SelectDropDown>
                     </Col>
                    <Col>
                     <FormGroup >
                    <Label style={{ fontSize: "16px", fontWeight: "bold" }}className="bold label-sm"> Skills</Label>
                   
               
                   {/* <div className="skill-select"> */}

                    <Select
                    className="skill-select"
                    styles={{height: "50px"}}
                      tabIndex="2"
                      name="option4"
                      // defaultInputValue={this.state.customerName}
                      value={primarySkill}
                      onChange={this.onChangePrimaryDrop}
                      options={option4}
                      
                    />
                   {/* </div> */}
                  </FormGroup>
                  <span style={{ color: "red", fontSize: "12px" }}>{primarySkillGroupError}</span>
                { this.state.filteredValueArray.length >0 && <div style={{width:"100%",display:"flex",flexWrap:"wrap",border:"1px solid grey",marginTop:"2.3rem"}}>
                      {
                        this.state.filteredValueArray.map((data)=>{
                          return (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                minWidth: "100px",
                                background: "#ECECEC",
                                border: "none",
                                minHeight: "50px",
                                marginTop: "0.5rem",
                                marginLeft: "0.5rem",
                                borderRadius: "5px",
                                padding: "0.5rem",
                              }}
                            >
                              <span style={{marginRight:"4px"}}>{data}</span>

                              <h3
                              
                                data-toggle="tooltip"
                                data-placement="top"
                                title="cancel"
                                onClick={() => this.closeDataSkill(data)}
                                style={{
                                  color: "#04044c",
                                }}
                              >
                                {" "}
                                <MdCancel color="red" size="20" />{" "}
                              </h3>
                            </div>
                          );
                        })
                      }
                    </div>}
                  

                  </Col>
                 

                 
                  
                  </Row>

                  <div className="center">
                    <Button
                       tabIndex="7"
                        disabled={this.state.buttonAction}
                      type="submit"
                      style={{
                        background: "#0984e3",
                        marginTop: "30px",
                        color: "white",
                      }}
                      className="btn login-button white-text"
                    >
                      Submit
                    </Button>
                  </div>
                </Form>

                {message && <Notifier message={message} />}
                {error && <ErrorNotifier message={error} />}
              </div>
            </div>
          </div>
        ) : (
          <div>
            <i
              className="material-icons cancel-button pointer"
              onClick={this.props.back}
            >
              cancel
            </i>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "24px",
                  fontWeight: "bold",
                  paddingTop: "0.5rem",
                }}
              >
                <span> Technical Skills </span>
              </div>
              <div>
                <Form onSubmit={this.onUpdate} className="p-3" noValidate>
                <Row>
                    <Col>
                    <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                      Primary Skill Group
                    </span>
                     <SelectDropDown
                    
                     tab="1"
                     change={this.onChangeDrop}
                     name={primarySkillGroup}
                     value={primarySkillGroup}
                     options={this.state.data}
                     dropError ={dropdownError}
                     >


                     </SelectDropDown>
                     </Col>
                     <Col>
                     <FormGroup>
                    <Label className="bold label-sm">Primary Skills</Label>
                    <Select
                    className="skill-select"
                      tabIndex="2"
                      name="option4"
                      defaultInputValue={primarySkill}
                      value={primarySkill}
                      onChange={this.onChangePrimaryDrop}
                      options={option4}
                      
                    />
                  </FormGroup>
                 
                  { this.state.filteredValueArray.length >0 && <div style={{width:"100%",display:"flex",flexWrap:"wrap",border:"1px solid grey",marginTop:"2.3rem"}}>
                      {
                        this.state.filteredValueArray.map((data)=>{
                          return (
                            <div
                             
                              style={{
                                display: "flex",
                                justifyContent:"space-between",
                                alignItems:"center",
                                minWidth: "100px",
                                background: "#ECECEC",
                                border: "none",
                                minHeight: "50px",
                                marginTop: "0.5rem",
                                marginLeft: "0.5rem",
                                borderRadius: "5px",
                                padding:"0.5rem",
                                
                              }}
                            >
                              <span>{data}</span>
                              <h3
                                data-toggle="tooltip"
                                data-placement="top"
                                title="cancel"
                                onClick={()=>this.closeDataSkill(data)}
                                style={{
                                  color: "#04044c",
                                  cursor:"pointer"
                                  
                                }}
                              >
                                {" "}
                                <MdCancel color="red" size="20" />{" "}
                              </h3>
                            </div>
                          );
                        })
                      }
                    </div>}
                   </Col>
                    
                  </Row>

                  <div className="center">
                    <Button
                       tabIndex="7"
                        disabled={this.state.buttonAction}
                      type="submit"
                      style={{
                        background: "#0984e3",
                        marginTop: "30px",
                        color: "white",
                      }}
                      className="btn login-button white-text"
                    >
                      Update
                    </Button>
                  </div>
                </Form>

                {message && <Notifier message={message} />}
                {error && <ErrorNotifier message={error} />}
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}


const mapStateToProps = (state) => ({
  profile: state.profile,
});

export default connect(mapStateToProps,{getProfileInfo})(
  withRouter(UpdateTechnicalSkils)
);
